import {set_data_sync_exclusion} from '../networking/tbn_apis'

// Shared exclusion behavior for the Data Sync pages. Excluded results stay in place (grayed) and
// are left out of the active counts; toggling flips local state immediately and persists in the
// background (no spinner, no refetch). `domain` is 'yards' | 'vehicles' | 'drivers'.
// The component must provide `exclusions` (populated from the response), `user`, and `load_data`.
export function dataSyncExclusions(domain) {
  return {
    methods: {
      is_excluded(category, key) {
        return (this.exclusions[category] || []).indexOf(key) !== -1
      },
      // count of items NOT excluded (the active count shown in the badge)
      active_count(category, items, keyfn) {
        keyfn = keyfn || (x => x)
        return (items || []).filter(it => !this.is_excluded(category, keyfn(it))).length
      },
      // count of items excluded (the grayed second badge)
      excl_count(category, items, keyfn) {
        keyfn = keyfn || (x => x)
        return (items || []).filter(it => this.is_excluded(category, keyfn(it))).length
      },
      toggle_item(category, key) {
        const now = !this.is_excluded(category, key)
        // optimistic local flip so the item grays/ungrays instantly, no refetch
        const cur = Object.assign({}, this.exclusions)
        cur[category] = (cur[category] || []).filter(k => k !== key)
        if (now) cur[category] = cur[category].concat([key])
        this.exclusions = cur
        this._persist_exclusion(category, key, now)
      },
      async _persist_exclusion(category, key, excluded) {
        try {
          await set_data_sync_exclusion(this.user.tenant, domain, category, key, excluded)
        } catch (e) {
          this.$emit('showAlert', 'could not save the exclusion, try again', 'danger', 4000)
          if (this.load_data) this.load_data(true)  // silent resync to the server's truth
        }
      },
    },
  }
}
